import { OtpRequestType } from '@api/models/OtpRequestType';
import { callService } from '@api/remote-call';
import {
  KvkkRequestViewModel,
  SeturLoyaltySignUpDocumentsRequestViewModel,
} from '@api/v3';
import { encrypt, generateRandomIV } from '@utils/crypto';

import { RegisterFormData } from './components/RegisterForm';

export const registerRequest = async (form: RegisterFormData) => {
  const {
    name,
    surname,
    phoneNumber,
    email,
    password,
    kvkk,
    token,
    countryPhoneCode,
  } = form;

  const SECRET_KEY = process.env.NEXT_PUBLIC_ENCRYPT_SECRET_KEY ?? '';
  const ivForPassword = generateRandomIV();
  const encryptedPassword = encrypt(password, SECRET_KEY, ivForPassword);

  const response = await callService(
    { service: 'AuthService', method: 'register', version: 'v3' },
    {
      body: {
        firstName: name,
        lastName: surname,
        phone: phoneNumber,
        userName: email,
        password: encryptedPassword,
        kvkk,
        token: token,
        countryPhoneCode: countryPhoneCode,
        customerDocuments: [], // TODO should be checked where to get this field from
      },
    }
  );
  return response;
};

export const checkOtp = async ({
  type,
  code,
  refNo,
}: {
  type: OtpRequestType;
  code: string;
  refNo: string;
}) => {
  const response = callService(
    { service: 'AuthService', method: 'checkOtp', version: 'v3' },
    {
      body: { code, refNo, type },
    }
  );

  return response;
};

export const loyaltyLoginRequest = async ({
  email,
  birthDay,
  customerDocuments,
  mobileNumber,
  name,
  surname,
  countryCode,
  referencedBy,
  tckn,
  kvkk,
}: {
  email?: string;
  birthDay?: string;
  customerDocuments: SeturLoyaltySignUpDocumentsRequestViewModel[];
  mobileNumber?: string;
  name: string;
  surname: string;
  countryCode?: string;
  referencedBy?: string;
  tckn?: string;
  kvkk?: KvkkRequestViewModel;
}) => {
  return callService(
    { service: 'LoyaltiesService', method: 'loyaltySignUp', version: 'v3' },
    {
      body: {
        birthDay,
        customerDocuments,
        email,
        mobileNumber,
        name,
        surname,
        countryCode,
        referencedBy,
        tckn,
        kvkk,
      },
    }
  );
};

export const loginRequest = async ({
  email,
  password,
  token,
}: {
  email: string;
  password: string;
  token: string;
}) => {
  const SECRET_KEY = process.env.NEXT_PUBLIC_ENCRYPT_SECRET_KEY ?? '';
  const ivForPassword = generateRandomIV();
  const encryptedPassword = encrypt(password, SECRET_KEY, ivForPassword);

  return callService(
    { service: 'AuthService', method: 'token', version: 'v3' },
    {
      body: { userName: email, password: encryptedPassword, token },
    }
  );
};

export const passwordResetRequest = async ({
  email,
  token,
}: {
  email: string;
  token: string;
}) => {
  return await callService(
    {
      service: 'AuthService',
      method: 'passwordReset',
      version: 'v3',
    },
    {
      body: { userName: email, token },
    }
  );
};
